<script lang="ts" setup>
import recordUrl from '~ds/assets/illustrations/anyway-record.webp';
import { Illustration } from '~ds/components/ui/illustration-system';
import { Spinner } from '~ds/components/ui/spinner';
import { Text } from '~ds/components/ui/typography';

/**
 * The page while the student is being logged out: the spinning record and what is happening. It is
 * hidden from assistive tech; the layout announces the same words through a status region that is
 * there before the loader is, which screen readers read far more reliably than one mounted with its text.
 */
</script>

<template>
  <div class="flex h-dvh flex-col items-center justify-center bg-background" aria-hidden="true">
    <Spinner size="xl">
      <Illustration
        :src="recordUrl"
        alt=""
        size="auto"
      />
    </Spinner>
    <Text weight="medium" class="mt-3">
      {{ $t('general.common.loggingOut') }}
    </Text>
  </div>
</template>
